import { Expose, Type } from 'class-transformer'
import { Package } from 'react-feather'

import { Facility } from './Facility'
import { Sku } from './Sku'
import { SupplyChain } from './SupplyChain'

export class SkuByFacility {
  static type = 'skubyfacility'
  static typeDisplay = 'SKU By Facility'
  static icon = Package

  type = SkuByFacility.type
  typeDisplay = SkuByFacility.typeDisplay
  icon = SkuByFacility.icon

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Sku)
  sku?: Sku

  @Type(() => SupplyChain)
  @Expose({ name: 'supply_chain' })
  supplyChain?: SupplyChain

  @Expose({ name: 'num_units' })
  numUnits?: number

  @Expose({ name: 'num_available' })
  numAvailable?: number

  @Expose({ name: 'num_reserved' })
  numReserved?: number

}
